import config from '@/config'

export default {
  login: "登錄您的帳戶",
  relogin: "請重新登錄您的帳戶。",
  expired: "會話已過期！",
  denied: "許可被拒絕！",
  success: "成功",
  search_by_id: "按ID搜索，",
  successful_change_password: "您已成功更改密碼。",
  select_option: "選擇你的選項",
  no_data_available: "「沒有可用數據」，",
  no_rating_available: "無可用評級",
  successful_update_security: "您已成功更新安全性。",
  successful_disable_security: "您已成功禁用安全性。",
  update_security_confirm: "你確定要更新安全性嗎？",
  disable_security_confirm: "你確定要禁用安全性嗎？",
  change_operator_status_confirm: "你確定要更改運算符 \"{name}\" 狀態嗎？",
  change_member_status_confirm: "您確定要更改成員 \"{name}\" 狀態嗎？",
  change_bank_account_status_confirm: "您確定要更改 \"{name}\" 帳戶狀態嗎？",
  change_promotion_seq_confirm: "你確定要更改 \"{id}\" 序列嗎？",
  change_promo_status_confirm: "你確定要更改 \"{name}\" 促銷狀態嗎？",
  unlink_promotion_banner_confirm: "您確定要將 {view} 橫幅從促銷活動\"{id}\"解除連結嗎？",
  change_promo_signup_status_confirm: "您確定要更改 \"{name}\" 促銷註冊狀態嗎？",
  successful_update_account_setup: "您已成功更新帳戶設置。",
  unblock_member_confirm: "你確定要取消阻止成員 \"{name}\"嗎？",
  unblock_operator_confirm: "你確定要取消阻止運算符 \"{name}\"嗎？",
  block_sub_account_confirm: "你確定要阻止子帳戶 \"{name}\"嗎？",
  unblock_sub_account_confirm: "你確定要解鎖子帳戶 \"{name}\"嗎？",
  successful_update_account_password: "您已成功更新帳戶密碼。",
  change_affiliate_status_confirm: "你確定要更改代理 \"{name}\" 狀態嗎？",
  unblock_affiliate_confirm: "你確定要解鎖特工 \"{name}\"嗎？",
  change_coupon_status_confirm: "您確定要更改 \"{name}\" 優惠券狀態嗎？",
  submit_acknowledgement_confirm: "你確定要提交確認嗎？",
  change_bank_group_default_confirm: "你確定要將 \"{name}\" 設置為默認銀行組嗎？",
  change_withdrawal_limit_default_confirm: "您確定要將 \"{name}\" 設置為預設提款限額嗎？",
  change_promotion_group_default_confirm: "你確定要將 \"{name}\" 設置為默認的推廣組嗎？",
  change_withdrawal_limit_confirm: "您確定要更改 \"{name}\" 提款限額嗎？",
  change_promotion_group_confirm: "你確定要更改 \"{name}\" 推廣組嗎？",
  change_bank_group_confirm: "你確定要更改 \"{name}\" 銀行組嗎？",
  change_member_bet_limit_confirm: "您確定要更改 \"{name}\" \"{provider}\" 投注限額嗎？",
  assign_free_credit_confirm: "你確定要為\"{name}\"分配免費積分嗎？",
  update_survey_status_confirm: "您確定要更新調查狀態嗎？",
  move_banner_up_confirm: "你確定要將橫幅 \"{name}\" 向上移動嗎？",
  move_banner_down_confirm: "你確定要將橫幅 \"{name}\" 向下移動嗎？",
  delete_banner_confirm: "你確定要刪除橫幅 \"{name}\"嗎？",
  change_banner_status_confirm: "你確定要更改橫幅 \"{name}\" 狀態嗎？",
  delete_page_confirm: "你確定要刪除頁面 \"{name}\"嗎？",
  change_page_status_confirm: "你確定要更改頁面 \"{name}\" 狀態嗎？",
  clear_maintenance_time_confirm: "你確定要清除 \"{name}\" 維護時間嗎？",
  successful_clear_outstanding: "您已成功結清 {amt} 未結金額。",
  clear_outstanding_confirm: "你確定要清除 \"{name}\" outstanding嗎？",
  trace_outstanding_confirm: "你確定要追蹤 \"{name}\" 未完成嗎？",
  delete_ip_address_confirm: "你確定要刪除 \"{name}\" 下的ip \"{ip}\" 嗎？",
  change_payment_mode_status_confirm: "您確定要更改 \"{name}\" 付款方式狀態嗎？",
  redeposit_ticket_confirm: "你確定要重新存票嗎？",
  audit_ticket_confirm: "你確定要審核票嗎？",
  review_ticket_confirm: "你確定要查看工單嗎？",
  change_promotion_group_seq_confirm: "你確定要更改 \"{group}\" 下的 \"{promotion}\" 序列嗎？",
  move_affiliate_confirm: "你確定要將 \"{name}\" 的整個分支直接移動到 \"{operator}\" 下嗎？",
  cancel_unfinish_round_confirm: "你確定要取消未完成的回合 \"{round}\"嗎？",
  change_payment_mode_seq_confirm: "你確定要改變 \"{mode}\" 序列嗎？",
  change_label_status_confirm: "你確定要更改 \"{name}\" 標籤狀態嗎？",
  clear_iframe_url_confirm: "你確定要清除 iframe url 嗎？",
  delete_turnover_tier_confirm: "您確定要刪除 \"{name}\" 營業額層嗎？",
  vip_provider_rebate_batch_confirm: "您是否確認繼續進行VIP 提供者返利批量更新？",
  copy_rebate_rate_all_confirm: "你確定要將 \"{provider}\" 的 \"{name}\" 複製到所有提供者嗎？",
  edit_vip_confirm: "您想更新 \"{name}\" 的返傭率嗎？",
  add_promotion_custom_member_confirm: "您要添加促銷自定義成員清單嗎？",
  delete_promotion_custom_member_confirm: "添加您要刪除 \"{name}\" 促銷自定義成員清單？",
  change_rescue_fund_status_confirm: "你確定要更改{name}\"救援基金狀態嗎？",
  add_rescue_fund_custom_member_confirm: "要不要添加救援基金自定義會員名單？",
  delete_rescue_fund_custom_member_confirm: "添加您要刪除自定義成員清單rescue_fund \"{name}\"？",
  change_ads_status_confirm: "您確定要更改 \"{name}\" 廣告狀態嗎？",
  adjust_amount_bank_tooltip: "支持減號（-）從銀行賬戶餘額中扣除餘額",
  adjust_amount_operator_tooltip: "支持減號（-）從運營商錢包中扣除餘額",
  adjust_amount_member_tooltip: "支持減號 （-） 從會員餘額中扣除餘額",
  change_provider_game_seq_confirm: "你確定要改變 \"{mode}\" 序列嗎？",
  purchase_domain_confirm: "你確定要購買 \"{name}\" 功能變數名稱嗎？",
  search_by_domain_name: "按域名搜索，",
  search_by_domain_status: "按域狀態搜索，",
  search_by_account_id: "按帳戶ID搜索，",
  search_by_operator_id: "按運營商ID搜索，",
  search_by_full_name: "按全名搜索，",
  search_by_contact_phone: "按聯繫電話搜索，",
  search_by_signup_ip: "按註冊IP搜索，",
  search_by_referral_code: "按推薦代碼搜索，",
  search_by_bank_acc_no: "按銀行賬戶編號搜索，",
  search_by_affiliate_code: "按代理代碼搜索，",
  info1: "1. 不允許使用子功能變數名稱",
  info2: "2. 不需要'https://'或'http://'",
  info3: "3. 示例：abc.com",
  move_announcement_banner: "重新排序橫幅",
  atLeastOneChecked: "至少需要檢查一個閾值",
  adjustWalletTooltips: "支持減號（-）從代理錢包中扣除餘額",
  domain_status_update_confirm: "你想更新 \"{name}\" 狀態嗎？",
  move_banner_confirm: "你確定要將 \"{name}\" 更改為位置 \"{position}\"嗎？",
  delete_game_exclude_confirm: "你確定要刪除 \"{name}\"嗎？",
  banner_size_tooltips: "請遵循允許的圖像尺寸尺寸：\"{size}\".",
  purchase_domain_success: "購買功能變數名稱成功！，",
  apply_domain_success: "成功申請功能變數名稱！",
  search_by_lang_code: "按語言代碼搜索，",
  pleaseSelectAnImage: "請選擇一張圖片",
  pleaseSelectAValidImageType: "「請選擇有效的圖像類型」，",
  imageTooLargeMaxSizeAllowedIsOneMb: "圖像太大，允許的最大大小為 1MB",
  uploadYourLogoWithPngOrJpegFormat: "以 png 或 jpeg 格式上傳您的徽標",
  allowedPngAndJpegOnlyMaxOneMb: "僅允許 png 和 jpeg（圖像大小最大 1MB）",
  delete_theme_content_confirm: "你確定要刪除 \"{themecontent}\" 主題內容嗎？",
  delete_theme_confirm: "你確定要刪除 \"{theme}\" 主題嗎？",
  delete_color_confirm: "你確定要刪除 \"{color}\" 顏色嗎？",
  delete_content_confirm: "你確定要刪除 \"{content}\" 內容嗎？",
  needAiToGenerateLogo: "需要人工智慧生成標誌",
  previewImageForIllustrationOnly: "顯示的預覽圖像僅供說明之用。",
  actualResultMayVary: "實際結果可能會因網站增強而有所不同。",
  delete_theme_content_group_confirm: "你確定要刪除 \"{themecontentgroup}\" 主題內容組嗎？",
  change_theme_will_replace_menu: "你確定要更新主題嗎？（更改主題將導致功能表被替換）",
  change_provider_seq_confirm: "你確定要更改 \"{provider}\" 序列嗎？",
  change_provider_status_confirm: "您確定要更改 \"{provider}\" 提供者狀態嗎？",
  actionPerformWillReflectProd: "* 此處執行的任何作都將直接反映到生產",
  site_sync_confirm: "你確定要同步到製作嗎？",
  clear_profile_setting_maintenance_confirm: "你確定要清理維護嗎？",
  change_social_platform_status_confirm: "你確定要更改 \"{name}\" 社交平台狀態嗎？",
  search_by_site_name: "按網站名稱搜索，",
  change_social_account_status_confirm: "你確定要更改 \"{name}\" 社交帳戶狀態嗎？",
  themeMenuMessage1: "* 通過拖放功能表項重新排列功能表順序",
  themeMenuMessage2: "* 如果希望隱藏功能表項，請取消選中複選框",
  search_by_operator: "按運算子搜索，",
  search_by_ticket: "按票搜索，",
  search_member: "搜索會員",
  search_by_game_type: "按遊戲類型搜索，",
  tooltips_upload_size: "上傳的檔大小不能超過 1mb。",
  tooltips_href: "Href 欄位需要域擴展。例如：『yourwebsite.com/promotions』，填寫『促銷』就可以了。",
  d_winlose_chart: "可視化贏/輸和提款趨勢。",
  d_turnover_chart: "分析營業額和存款趨勢。",
  d_deposit: "顯示存款計數和唯一成員。",
  d_withdrawal: "顯示提款交易總數。",
  d_active_player: "玩家的總投注和唯一登錄次數。",
  d_winlose: "顯示淨贏/輸總數。",
  d_turnover: "產生的總營業額。",
  d_member: "所有註冊會員的計數。",
  d_referee: "用戶推薦總數。",
  d_verfied_signup: "經過驗證的使用者和新註冊的計數。",
  d_ftd: "首次存款的數量和金額。",
  d_top_winner: "玩家ID和總獲勝金額。",
  d_top_loser: "玩家ID和總損失金額。",
  d_top_deposit: "玩家ID和總存款金額從多到少。",
  d_top_withdrawal: "玩家ID和總提款金額從多到少。",
  d_top_promotion: "玩家的等級、晉陞ID、姓名和聲明。",
  d_payment_gateway: "通過網關的排名、方法、供應商、處理、拒絕、總和成功率。",
  tooltips_promo_member_custom: "請輸入多個成員ID，並帶有逗號分隔符。例如：member001，member002，member003",
  tooltips_social_facebook: "例如：https://www.facebook.com/",
  tooltips_social_instagram: "例如：https://www.instagram.com/",
  tooltips_social_skype: "例如：skype：<username>？chat",
  tooltips_social_telegram: "例如：https://t.me/<ID>",
  tooltips_social_tiktok: "例如：https://www.tiktok.com/<ID>",
  tooltips_social_wechat: "例如：<ID>，",
  tooltips_social_whatsapp: "例如：https://wa.me/<ID>",
  tooltips_social_youtube: "例如：https://www.youtube.com/<ID>",
  search_by_business_id: "按企業ID搜索，",
  ticket_taken_confirm: "你確定要控制這個票證 ID \"{name}\"嗎？",
  tooltips_payment_setting: "只有當'設置'-'支付設置'設置為'OWN'時，才會反映以下內容",
  tooltips_cms_announcement_main: "最多 5 個公告橫幅，以獲得最佳用戶體驗",
  tooltips_cms_announcement_title: "最多 25 個字元以獲得最佳用戶體驗",
  tooltips_cms_announcement_body: "最多 200 個字元，每行 40 個字元，以獲得最佳用戶體驗",
  delete_livechat_confirm: "你確定要刪除即時聊天嗎？",
  tooltips_vip_name: "最多 10 個字元以獲得最佳用戶體驗",
  tooltips_sequence: "序列數量越少，遊戲優先順序就越高。",
  tooltips_turnover: "會員流失率",
  tooltips_rebate_rate: "會員回贈率 %",
  tooltips_promo_bonus_rate: "推薦 100%。任何超過 100% 的超額部分將由運營商負責。",
  tooltips_promo_signup: "建議在 1 澳元至 20 澳元之間。任何超過 1 澳元至 20 澳元的超額部分將由運營商負責。",
  tooltips_bonus_issue: "建議在 1-AUD1000 澳元之間。任何超過 1 澳元AUD1000的超額部分將由運營商負責。",
  tooltips_vip_cycle_day: "VIP 週期以天為單位。",
  vip_info1: "VIP等級一旦創建，只能編輯，不能刪除。",
  website_launched: "顯示已啟動的網站總數、迄今為止的網站總數、運營商總數和今天的活躍網站。",
  new_player_verified_signup: "顯示新玩家數量、活躍玩家總數以及截至所選日期的玩家總數。",
  depo_withdrawal_diff: "顯示存款和取款總金額、存款明細和取款明細之間的差額。",
  bonus: "顯示領取的獎金總額和領取成功總數。",
  ggr: "顯示所選日期的總遊戲收入和會員總餘額。",
  turnover: "顯示截至所選日期的總營業額和當前 RTP 百分比。",
  provider_pt_on_global_confirm: "你確定要更新提供者 \"{name}\" PT 的標準嗎？",
  approve_affiliate_ticket_confirm: "您確定要批准代理工單嗎？",
  change_payment_option_recommend_confirm: "你確定要更改 \"{mode}\" 下的 \"{group}\" 推薦嗎？",
  pleaseFillUpSiteDetails: "請填寫您的網站詳細資訊",
  chooseYourPreferedResponsiveLayoutTheme: "選擇您喜歡的響應式布局主題",
  chooseYourPreferedColor: "選擇你喜歡的顏色",
  pleaseSelectTheme: "請選擇主題",
  pleaseSelectColor: "「請選擇顏色」，",
  websiteLayoutAndThemeDesign: "「網站佈局和主題設計」，",
  operatorAccCreatedSuccessful: "運營商帳戶創建成功",
  search_by_template_code: "按範本代碼搜索，",
  delete_mini_game_confirm: "你確定要刪除\"{minigame}\"小遊戲嗎？",
  delete_mini_game_template_confirm: "你確定要刪除\"{minigametemplate}\"小遊戲範本嗎？",
  search_by_game_name: "按遊戲名稱搜索，",
  tooltips_gamereward: "限制：{max}，",
  change_gamify_status_confirm: "你確定要更改 \"{gamify}\" 獎勵狀態嗎？",
  change_gamify_daily_login_status_confirm: "您確定要更改每日簽到（每日登錄）獎勵狀態嗎？",
  change_partner_seq_confirm: "你確定要更改 \"{id}\" 序列嗎？",
  tooltips_partners_link: "例如：https://www.google.com/",
  delete_partner_confirm: "你確定要刪除合作夥伴 \"{name}\"嗎？",
  change_account_chat_status_confirm: "您確定要更改即時聊天狀態嗎？",
  uploadYourManifestWithPngJpegFormat: "上傳 png 或 jpeg 格式的清單",
  whitelist_ip_tooltips: "請通知提供者將ip 列入白名單：\"{ip}\"。",
  tooltips_inpay_api_url: "例如：https://www.google.com/",
  delete_android_app_link_confirm: "你確定要刪除 \"{name}\" 的 android 應用程式連結嗎？",
  info_app_link: "例如：https://www.google.com/",
  cpi_enrol_confirm: "您確定要報名參加 CPI 嗎？",
  change_cpi_member_status_confirm: "您確定要更改 CPI 成員\"{name}\"的狀態嗎？",
  change_leaderboard_status_confirm: "您確定要更改排行榜\"{name}\"的狀態嗎？",
  delete_leaderboard_confirm: "您確定要刪除排行榜\"{name}\"嗎？",
  tooltips_leaderboard_campaign: "最多可同時進行 5 個排行榜活動",
  tooltips_cpi_operator_phone: "最多可群呼 5 通電話",
  delete_phone_confirm: "您確定要刪除電話\"{name}\"嗎？",
  excel_format: "上傳範例 Excel 格式。",
  choose_an_excel_file: "選擇一個 Excel 檔案",
  tooltips_cpi_operator_phone_2: "請選擇 {name} 的電話號碼",
  will_start_call_now: "將立即開始撥打電話",
  withdrawal_confirm: "您確定要從\"{provider}\"提款嗎？",
  service_not_available: "服務不可用。",
  change_cpi_custom_assignee_confirm: "您確定要更改自訂 cpi \"{name}\" 的負責人嗎？",
  change_cpi_custom_urgency_confirm: "您確定要更改自訂 cpi \"{name}\" 的緊急程度嗎？",
  delete_cpi_custom_confirm: "您確定要刪除自訂 cpi \"{name}\" 嗎？",
  change_ai_assistant_status_confirm: "您確定要更改AI助理的狀態嗎？",
  please_enter_valid_phone: "請輸入有效的電話",
  tooltip_promo_signup: "金流轉帳的提供商不可包含在促銷註冊內。",
  tooltips_add_cpi_op_phone: "例如：84123456789",
  tooltips_free_point: "{point} 點數 = {currency} 1",
  search_by_second_id: "以第二ID搜尋",
  tooltips_allow_one_active_livechat: "只允許 1 個 LiveChat 同時進行",
  tooltips_add_cpi_op_phone_myr: "60123456789",
  allowedPngOnlyMaxOneMb: "僅允許 PNG（圖片大小上限 1MB）",
  uploadYourLogoWithPngFormat: "請以上傳 PNG 格式的標誌",
  add_promotion_voucher_custom_member_confirm: "您確定要新增優惠券自訂會員列表嗎？",
  delete_promotion_voucher_custom_member_confirm: "您確定要從優惠券自訂會員列表中刪除\"{name}\"嗎？",
  redeposit_ticket_voucher_confirm: "您確定要重新入金工單憑證嗎？",
  change_mission_status_confirm: "您確定要更改任務 \"{name}\" 的狀態嗎？",
  mission_reward_at_least_one: "請至少提供一項獎勵：點數、額度、收件匣或活動。",
  mission_invalid_reward_numbers: "若有填寫，點數、額度及收件匣必須為有效數字。",
  mission_campaign_required_when_inbox: "當 Inbox 設定時，請選擇 Campaign。",
  mission_rule_target_invalid: "請輸入有效的目標值。",
  change_trigger_status_confirm: "您確定要更改觸發條件\"{name}\"的狀態嗎？",
  free_credit_withdrawal_amount: "顯示截至所選日期的免費額度提款總額。",
  check_freespin_result_message_0: "0 = 已分配獎勵",
  check_freespin_result_message_1: "1 = 免費遊戲進行中（玩家已查看 Big Text 並正在旋轉）",
  check_freespin_result_message_2: "2 = 免費遊戲階段已完成，正在進行獎勵領取流程",
  check_freespin_result_message_3: "3 = 已領取獎勵",
  check_freespin_result_message_400: "400 = 獎勵已被操作員取消",
  check_freespin_result_message_500: "500 = 獎勵已過期",
  cancel_free_round_confirm: "您確定要取消免費回合\"{round}\" 嗎？",
  issue_free_spin_rule: "規則：最高贏額不得大於總線數 × 每線投注 × 投注值 × 5000（MaxWinCapMultiplier）。",
  delete_deposit_tier_confirm: "您確定要刪除存款等級 \"存款：{deposit}，獎勵：{reward}\" 嗎？",
  tooltips_promo_voucher_bonus_rate: "最高獎勵率為2%",
  noExtraSpacingInLogo: "Logo 請勿保留多餘留白",
  logoDimensionTips: "尺寸：寬度：最多 250px，高度：50px（例如：250px × 50px）",
  mission_invalid_reward_number_point: "若有填寫，點數必須為有效數字。",
  mission_reward_enter_point: "請輸入點數",
  change_reward_rain_status_confirm: "您確定要變更\"{name}\"的狀態嗎？",
  cancel_reward_rain_session_confirm: "您確定要取消\"{name}\"嗎？",
  change_banner_slide_show_status_confirm: "您確定要變更橫幅\"{name}\"的輪播顯示嗎？",
  change_news_status_confirm: "您確定要變更新聞\"{name}\"的狀態嗎？",
  delete_news_confirm: "您確定要刪除新聞\"{name}\"嗎？",
  move_news_confirm: "您確定要將\"{name}\"移至\"{position}\"位置嗎？",
  info_slug: "每個單字之間請使用一個連字號 (-)。例如：hello-world-test",
};